export default {"src":"/_next/static/media/ktu.59ce3335.svg","height":529,"width":955,"blurWidth":0,"blurHeight":0};